import { render, staticRenderFns } from "./SignupOptions.vue?vue&type=template&id=8c08970e&"
import script from "./SignupOptions.vue?vue&type=script&lang=js&"
export * from "./SignupOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports